import React from "react";
import Avatar from "@mui/material/Avatar";
import { makeStyles } from "tss-react/mui";
import { DATA_SOURCE } from "../../util/Data/DataModeling";

const useStyles = makeStyles()(() => ({
  IconHolder: {
    height: "25px",
    width: "25px",
    borderRadius: "50px",
    margin: "0 10px 0 0",
    padding: "5px 5px",
    fontSize: "19px",
  },
}));

function ComponentAvatar(props) {
  const { classes } = useStyles();
  const { componentType } = props;
  return (
    <Avatar
      alt={componentType}
      className={classes.IconHolder}
      src={componentType === DATA_SOURCE.singular ? "/images/database.png" : "/images/columns.png"}
      sx={{
        width: 24,
        height: 24,
      }}
    />
  );
}

export default React.memo(ComponentAvatar);
